import {
  tcoFieldsIds,
  tcoGeneralInformationFieldIds,
} from 'utils/defaultsAndConstants/constants';

const {
  costOfCapitalFieldId,
  varDiscountFieldId,
  salesTaxFieldId,
  shippingHandlingFieldId,
} = tcoFieldsIds;

const {
  operatingLabourCostPerHourId,
  annualLaborInflationRateId,
  efficiencyLaborTransferOrReductionId,
} = tcoGeneralInformationFieldIds;

export const tcoFieldDecimalConfig: Record<string, number> = {
  [costOfCapitalFieldId]: 1,
  [varDiscountFieldId]: 0,
  [salesTaxFieldId]: 2,
  [shippingHandlingFieldId]: 0,
  [operatingLabourCostPerHourId]: 2,
  [annualLaborInflationRateId]: 1,
  [efficiencyLaborTransferOrReductionId]: 0,
};
